module.exports = ['$scope', 'locale', ($scope, locale) ->
  @provinces = if locale.isFrench()
    AB: 'Alberta'
    BC: 'Colombie-Britannique'
    PE: 'Île-du-Prince-Édouard'
    MB: 'Manitoba'
    NB: 'Nouveau-Brunswick'
    NS: 'Nouvelle-Écosse'
    ON: 'Ontario'
    SK: 'Saskatchewan'
    NL: 'Terre-Neuve-et-Labrador'
    QC: 'Québec'
    NT: 'Territoires du Nord-Ouest'
    YT: 'Yukon'
    NU: 'Nunavut'
  else
    AB: 'Alberta'
    BC: 'British Columbia'
    MB: 'Manitoba'
    NB: 'New Brunswick'
    NL: 'Newfoundland and Labrador'
    NS: 'Nova Scotia'
    ON: 'Ontario'
    PE: 'Prince Edward Island'
    QC: 'Quebec'
    SK: 'Saskatchewan'
    NT: 'Northwest Territories'
    YT: 'Yukon'
    NU: 'Nunavut'

  @
]
